export interface FloatingMenuPosition {
    left: number;
    width: number;
    top?: number;
    bottom?: number;
    maxHeight: number;
}

const TRIGGER_GAP = 4;
const VIEWPORT_MARGIN = 8;

// Anchoring an upward menu by `bottom` keeps it flush with the trigger however short its content is.
export function floatingMenuPosition(
    trigger: Pick<DOMRect, 'top' | 'bottom' | 'left' | 'width'>,
    viewportHeight: number,
    preferredMaxHeight: number,
): FloatingMenuPosition {
    const spaceBelow = Math.max(0, viewportHeight - trigger.bottom - TRIGGER_GAP - VIEWPORT_MARGIN);
    const spaceAbove = Math.max(0, trigger.top - TRIGGER_GAP - VIEWPORT_MARGIN);
    const horizontal = { left: trigger.left, width: trigger.width };

    if (spaceBelow < preferredMaxHeight && spaceAbove > spaceBelow) {
        return {
            ...horizontal,
            bottom: viewportHeight - trigger.top + TRIGGER_GAP,
            maxHeight: Math.min(preferredMaxHeight, spaceAbove),
        };
    }

    return {
        ...horizontal,
        top: trigger.bottom + TRIGGER_GAP,
        maxHeight: Math.min(preferredMaxHeight, spaceBelow),
    };
}
